import { Injectable } from "@angular/core";
import { StatisticsRepository } from "../statistics.repository";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class GetTotalBetsCountUseCase implements IUseCase<void, Observable<number>> {
    constructor(private statisticsRepository: StatisticsRepository) {
    }

    execute(): Observable<number> {
        return this.statisticsRepository.subscribeTotalBetsCount();
    }
}
